<template>
        <v-layout row wrap>
            <v-flex xs10 class="mx-0 px-0">
                <v-card>                
                    <v-card-title>
                        <h2 class="grey--text text--darken-2">Register</h2>                                                
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>                                                                            
                        Registrieren zur Zeit nicht möglich  
                    </v-card-text>
                    <v-card-actions>´ 
                        <v-flex xs4 offset-xs6>
                           
                            <router-link to="/dashboard" exact>
                                <v-btn icon>
                                    <v-icon x-large class="red--text">close</v-icon>
                                </v-btn>
                            </router-link>
                        </v-flex>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>       
</template>

<script>

import formHelper from '../formHelper.vue'
export default {
     
    data() {
        return {
            
        }
    },
    methods: {
        
    }
}
</script>

<style >

    
    
</style>


// WEBPACK FOOTER //
// register.vue?946eec52